const SHARE_ICON = `
<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M17.8857 10.627V14.127C17.8857 15.5271 17.8857 16.2271 17.6133 16.7619C17.3736 17.2323 16.9911 17.6148 16.5207 17.8545C15.9859 18.127 15.2859 18.127 13.8857 18.127H6.88574C5.48561 18.127 4.78555 18.127 4.25077 17.8545C3.78036 17.6148 3.39791 17.2323 3.15823 16.7619C2.88574 16.2271 2.88574 15.5271 2.88574 14.127V10.627M13.7191 6.46029L10.3857 3.12695M10.3857 3.12695L7.05241 6.46029M10.3857 3.12695V13.127" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;

export default SHARE_ICON;
